import { ApiRoutes } from "@/enums/apiRoutes.enum";
import { createCustomerQueryParamsObject } from "@/hooks/utils";
import axios from "@/lib/axios";
import {
  AssignCouponProps,
  AssignPointsProps,
  ExportFormPayload,
} from "@/types/data";
import {
  convertCustomersResponse,
  convertCustomerStatsResponse,
  CustomerDetailsDto,
} from "@/utils/converters";

export const customerService = {
  async getAll(query: Record<string, string | number>) {
    const response = await axios.post(ApiRoutes.CUSTOMERS, query);
    return {
      ...response.data,
      items: convertCustomersResponse(response.data.items),
    };
  },

  async getStats(query: Record<string, string | number>) {
    const response = await axios.post(ApiRoutes.CUSTOMERS_STATS, query);
    return response.data;
  },

  async getDetails(id: string | number) {
    const response = await axios.get<CustomerDetailsDto>(
      `${ApiRoutes.CUSTOMERS_DETAILS}/${id}`,
    );
    return convertCustomerStatsResponse(response.data);
  },

  async export(data: ExportFormPayload) {
    const response = await axios.post(ApiRoutes.EXPORT_CUSTOMERS, data);
    return response.data;
  },

  async assignCoupon(payload: AssignCouponProps) {
    const response = await axios.post(ApiRoutes.ASSIGN_REWARD_POINTS, payload);
    return response.data;
  },

  async assignPoints(payload: AssignPointsProps) {
    const response = await axios.post(ApiRoutes.ASSIGN_REWARD_POINTS, payload);
    return response.data;
  },

  async getFilterOptions() {
    const response = await axios.get(ApiRoutes.FILTERS_OPTIONS);
    return response.data;
  },

  async getAllPaginated<T>(
    query: Record<string, string | number>,
  ): Promise<T[]> {
    let currentPage = 1;
    let totalPages = 1;
    const allItems: T[] = [];

    do {
      const queryObject = createCustomerQueryParamsObject({
        ...query,
        page: currentPage,
        pageSize: 50,
        currentPage,
        totalPages,
      });

      const data = await this.getAll(queryObject);
      allItems.push(...data.items);
      totalPages = data.total_pages;
      currentPage++;
    } while (currentPage <= totalPages);

    return allItems;
  },
};
